/* eslint-disable */
export default {
  allCalls: '所有通话',
  Unknown: '未知',
  Multiple: '多个',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
